import React from "react";
import { Card } from "../../ui";
import { DataTable } from "../../common/DataTable";

// columns: [{ key, header, render?(row), className? }]
// rows: array of data objects (must each have a stable `id`)
const VaptTable = ({ columns, rows, onRowClick, emptyMessage = "No records found.", loading = false }) => {
  const dataTableColumns = columns.map((col) => ({
    id: col.key,
    header: col.header,
    enableSorting: false,
    cell: ({ row }) => (
      <span className={col.className || ""}>{col.render ? col.render(row.original) : row.original[col.key]}</span>
    ),
  }));

  return (
    <Card padded={false} hover={false} className="overflow-hidden">
      <DataTable
        columns={dataTableColumns}
        data={rows || []}
        getRowId={(row) => String(row.id)}
        loading={loading}
        emptyMessage={emptyMessage}
        onRowClick={onRowClick}
        enableColumnVisibility={false}
        enableColumnResizing
        maxBodyHeight="65vh"
      />
    </Card>
  );
};

export default VaptTable;
